import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useHistory } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { fetchData, postData, SyncData, updateData, deleteData, TripCustomerfetchData } from '../../../apiService';
import { Card, CardContent, IconButton, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import Button from '@mui/material/Button';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Select from 'react-select';
import Paper from '@mui/material/Paper';
import { Tooltip } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import DeleteIcon from '@mui/icons-material/Delete';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Link } from 'react-router-dom';
import { ThreeDRotationOutlined } from '@material-ui/icons';
import { Discount } from '@mui/icons-material';
import { FaHtml5, FaWeight } from 'react-icons/fa';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa'; // Example for FontAwesome Icon
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios'; // Make sure axios is installed and imported
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CircularProgress from '@mui/material/CircularProgress';


const AdditionalOrderEdit = () => {
    const { id } = useParams();

    const history = useHistory();
    const { isAuthenticated, companyId, userId, permissions, token, logout } = useAuth();

    // State to control the visibility of the container
    const [isContainerVisible, setIsContainerVisible] = useState(false);

    const toggleContainerVisibility = () => setIsContainerVisible(!isContainerVisible);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [quantity, setQuantity] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [totalQuantity, setTotalQuantity] = useState(0);
    const [customerName, setCustomerName] = useState('');
    const [rate, setRate] = useState('');
    const [discount, setDiscount] = useState(''); // Correct 
    const [singlediscount, setsingleDiscount] = useState(''); // Correct capitalization
    const [gstRate, setGSTRate] = useState('');
    const [paymentMode, setPaymentMode] = useState('');
    const [tripdate, setTripdate] = useState('');
    const [customerId, setCustomerId] = useState('');
    const [qty, setQty] = useState('');
    const [discountPerPiece, setDiscountPerPiece] = useState('');
    const [loading, setLoading] = useState(false);
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [Remarks, setRemarks] = useState("");

    const [items, setitems] = useState('');
    const [isReturnsale, setisReturn] = useState('');
    const [bundle, setBundle] = useState(null);
    const [Bundle, setbundle] = useState(null);
    const [pieces, setPieces] = useState('');
    const [LastBillDate, setLastBillDate] = useState("");
    const [LastBillAmount, setLastBillAmount] = useState("");
    const [Outstanding, setOutstanding] = useState("");
    const [pricetype, setpricetype] = useState('');
    const [categoryId, setCategoryId] = useState('');
    const [productCategoryId, setPCategoryId] = useState('');
    const [itemId, setItemId] = useState('');
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [pcategoryOptions, setPCategoryOptions] = useState([]);
    const [itemOptions, setItemOptions] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedPCategory, setSelectedPCategory] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);
    const [itemnameget, setItemName] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [selecteditems, setSelectedItems] = useState("");
    const [itemsOptions, setItemsrOptions] = useState([]);
    const [selectedItemsType, setSelectedItemsType] = useState("");
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [formData, setFormData] = useState([]);
    const [itemdata, setData] = useState([]);
    const [tripId, setTripId] = useState("");
    const [QtyBundle, setQtyBundle] = useState('');
    const [Route, setRoute] = useState([]);
    const [orderDate, setOrderDate] = useState('');
    const [invoice, setInvoice] = useState('');
    const [TripWiseID, setTripWiseID] = useState('');
    const [routeId, setrouteId] = useState('');
    const [SaleRemarks, setsaleRemarks] = useState('');
    const [CustName, setCustName] = useState('');
    const[addressLine1, setaddressLine1]=useState('');
    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        fetchItemData();
    }, [isAuthenticated, companyId, token, logout]);


    // Add a function to format the date
    const formatDateForInput = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        let month = (date.getMonth() + 1).toString();
        let day = date.getDate().toString();

        // Pad the month and day with leading zeros if needed
        month = month.length === 1 ? `0${month}` : month;
        day = day.length === 1 ? `0${day}` : day;

        return `${year}-${month}-${day}`;
    };
    const formatTimeForInput = (timeString) => {
        const time = new Date(`1970-01-01T${timeString}`);
        const hours = time.getHours().toString().padStart(2, '0');
        const minutes = time.getMinutes().toString().padStart(2, '0');
        const seconds = time.getSeconds().toString().padStart(2, '0');

        return `${hours}:${minutes}:${seconds}`;
    };

    const hasCreateTransactionPermission = permissions.includes('Create Transaction');
    const hasEditTransactionPermission = permissions.includes('Edit Transaction');
    const hasDeleteTransactionPermission = permissions.includes('Delete Transaction');

    useEffect(() => {

        fetchData('AdditionalOrderEditAPI', `/${id}`, token)
            .then((response) => {
                
                const array = response.response_data.saleOrder;

                if (response.responseCode === '1111') {
                    setFormData(response.response_data.saleOrder);
                    setCustomerId(response.response_data.saleOrder.customerId);
                    setData(response.response_data.saleOrderDetails);
                    setrouteId(response.response_data.saleOrder.routeId);
                    setItemList(response.response_data.saleOrderDetails);
                    setCustomerName(response.response_data.SaleOrder.customerName);
                    setaddressLine1(response.response_data.SaleOrder.addressLine1)
                    setsaleRemarks(response.response_data.saleOrder.saleRemarks);
                    setTripId(response.response_data.saleOrder.tripId);
                    setTripWiseID(response.response_data.saleOrder.tripId);
                    setRoute(array.route);
                    setOrderDate(response.response_data.saleOrder.orderDate);
                    console.log(response.response_data.saleOrderDetails);

                }
                setFormData((prevData) => ({
                    ...prevData,
                    ModifiedBy: userId,
                }));
            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            });
    }, [id]);


    const handleSubmit = (event) => {
        event.preventDefault();
        setFormData(prevData => ({
            ...prevData,
            ModifiedBy: userId,
        }));
        const CreateData = {
            SaleOrder: formData,
            SaleOrderDetails: itemdata
        };
        updateData('SaleApi', `${id}`, CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push(`/AddtionalOrderIndex/${tripId}`);
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });
    };

    const removeRecord = (index) => {
        const isConfirmed = window.confirm("Are you sure you want to remove the record?");
        if (isConfirmed) {
            const updatedRecords = [...itemdata];
            updatedRecords.splice(index, 1);
            setData(updatedRecords);
        }
    };

    //Items
    const fetchItems = async () => {
        try {
            const response = await fetchData('DespatchReport', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(item => ({
                    value: item.Id,
                    label: item.Name
                }));
                setItemsrOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handleItemsChange = (selectedOption) => {
        setSelectedItemsType(selectedOption);
    };

    useEffect(() => {
        fetchItems();
    }, []);

    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };


    const fetchItemData = async () => {
        try {
           
            const response = await fetchData('AdditionalOrderEditAPI', `/${id}`, token);
            if (response.responseCode === '1111') {
                setFormData(response.response_data.saleOrder); //TripId
                setCustomerId(response.response_data.saleOrder.customerId);
                setCustomerName(response.response_data.saleOrder.customerName);
                setData(response.response_data.saleOrderDetails);
                setItemList(response.response_data.saleOrderDetails);
                setrouteId(response.response_data.saleOrder.routeId);
                setOrderDate(response.response_data.saleOrder.orderDate);
                const tripid = response.response_data.saleOrder.tripId;
                setTripId(tripid);
                console.log(tripid);
            }
            //setIsModalOpen(true);
        } catch (error) {
            console.error('Error fetching Item', error);
        }
    };



    //Product catgory
    useEffect(() => {
        const fetchPCategoryTypes = async () => {
            try {
                const response = await fetchData('ProductCategoryApi', `/${companyId}`, token);
                if (response.responseCode === '1111') {
                    const dataArray = response.response_data;
                    const options = response.response_data.map(pcat => ({
                        value: pcat.id,
                        label: pcat.name
                    }));
                    setPCategoryOptions(options);
                    setPCategoryId(dataArray[0].id);
                }
            } catch (error) {
                console.error('Error fetching categories:', error);
            }
        };
        fetchPCategoryTypes();
    }, [companyId, token]);

    const handlePCategoryChange = (selectedOption) => {

        setSelectedPCategory(selectedOption);
        fetchCategoryTypes(selectedOption.value);
        setPCategoryId(selectedOption.value);
        setSelectedItem(null);
        setSelectedCategory(null);

    };

    //varient
    const fetchCategoryTypes = async (productCategoryId) => {
        try {
            const response = await fetchData('CategoryApi', `/${companyId}/${productCategoryId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(cat => ({
                    value: cat.id,
                    label: cat.name
                }));
                setCategoryOptions(options);
            }
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };


    const handleCategoryChange = (selectedOption) => {
        setSelectedCategory(selectedOption);
        fetchItemsTypes(selectedOption.value);
        setCategoryId(selectedOption.value);
        setSelectedItem(null);
    };

    const fetchItemsTypes = async (categoryId) => {
        try {
            const response = await fetchData('ItemApi', `/${companyId}/${categoryId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(item => ({
                    value: item.id,
                    label: item.name
                }));
                setItemOptions(options);
            }
        } catch (error) {
            console.error('Error fetching items:', error);
        }
    };


    const handleItemChange = async (selectedOptions) => {
        setSelectedItem(selectedOptions);
        const ItemID = selectedOptions.value;
        setItemId(ItemID);

        try {
            const response = await fetchData('RoutePriceTypeApi', `/${routeId}/${ItemID}`, token);

            if (response && response.response_data && response.response_data.length > 0) {
                let itemFound = false;

                // Iterate through each category in response_data
                response.response_data.forEach(category => {
                    if (category.Items && category.Items.length > 0) {
                        category.Items.forEach(item => {
                            if (!itemFound) {
                                console.log(`Processing item: ${item.Name}`);
                                // Process each item here
                                // Extract numeric part from Weight

                                const { Rate, GSTRate, Weight, bundle, QtyBundle } = item;
                                const numericWeight = parseFloat(Weight);
                                setRate(Rate);
                                setGSTRate(GSTRate);
                                setBundle(bundle);
                                setQtyBundle(QtyBundle);
                                setNewItem((prevItem) => ({
                                    ...prevItem,
                                    weight: numericWeight, // Add weight to the newItem state
                                    rate: Rate,
                                    gstRate: GSTRate,
                                    //Bundle: Bundle,
                                    bundle: bundle ?? 0, // Set Bundle to 0 if it's null
                                    QtyBundle: QtyBundle ?? 0,
                                }));
                                itemFound = true; // Set itemFound to true when an item is processed
                            }
                        });
                    }
                });

                if (!itemFound) {
                    console.error('No items found in the response data');
                }
            } else {
                console.error('Invalid response structure');
            }
        } catch (error) {
            console.error('Error fetching item rate:', error);
        }
    };

    const [newItem, setNewItem] = useState("");



    useEffect(() => {
        const Quantity = parseInt(qty) || 0;
        const gstAmount = (rate * gstRate) / 100;
        const totalAmount = rate * Quantity;
        const totalPlusGst = totalAmount + gstAmount;
        //const bundle = bundle;

        setNewItem((prevItem) => ({
            ...prevItem,
            Rate: rate,
            totalAmount: totalAmount,
            gstAmount: gstAmount,
            totalPlusGst: totalPlusGst,
            discount: discount, // Ensure correct reference
            bundle: bundle,
            //pieces: pieceCount,
        }));
    }, [rate, qty, discount, gstRate, bundle]); // Added dependencies

    const [itemList, setItemList] = useState([]);


    //dulicate check
    const isDuplicateItem = (itemList, newItem) => {
        return itemList.some(item => item.ItemId === newItem.ItemId);
    };


    const AddtoListdata = (e) => {
        e.preventDefault();
        if (qty > 0) {
            const quantity = parseInt(qty);
            const discountPerPiece = newItem.discountPerPiece || 0; // Default to 0 if DiscountPerPiece is null or undefined
            const discount = parseInt(discountPerPiece) || 0;
            const bundleSize = parseInt(newItem.QtyBundle) || 0; // Default to 1 if Bundle is null or 0
            const numBundles = bundleSize ? Math.floor(quantity / bundleSize) : 0;
            const pieceCount = bundleSize ? quantity % bundleSize : 0;
            const ratePerKg = rate;
            const isdelete = true;
            const gstRate = newItem.gstRate || 0;

            let RateAfterDiscount = 0;

            if (discount > 0) {
                RateAfterDiscount = ratePerKg - discount;
            }
            else {
                RateAfterDiscount = rate;
            }
            const totalQty = newItem.weight * quantity;
            const totalAmount = ratePerKg * quantity;
            const TotalAmtperkgwise = ratePerKg * totalQty;
            const taxableAmt = ((RateAfterDiscount) * totalQty * 100) / (100 + gstRate);
            const gstAmt = (taxableAmt * gstRate) / 100;
            const GstPer = (gstAmt / taxableAmt) * 100;
            const netAmt = taxableAmt + gstAmt;

            const updatedItem = {
                ...newItem,
                item: selectedItem.label,
                ItemId: selectedItem.value,
                quantity: quantity,
                rate: rate,
                RateAfterDiscount: RateAfterDiscount,
                gstRate: gstRate,
                totalAmount: totalAmount,
                netAmt: netAmt,
                discount: discount,
                totalQty: totalQty,
                ratePerKg: ratePerKg,
                TotalAmtperkgwise: TotalAmtperkgwise,
                taxableAmt: taxableAmt,
                gstAmt: gstAmt,
                gstPer: GstPer,
                bundle: numBundles,
                pieces: pieceCount,
                Isdelete: isdelete,
                QtyBundle: QtyBundle,
            };
            // Check for duplicates
            if (isDuplicateItem(itemList, updatedItem)) {
                alert("This Item already exists in the list.");
                return;
            }

            // Updating state
            setItemList([...itemList, updatedItem]);

            // Resetting newItem state
            setNewItem({
                ItemId: '',
                Name: '',
                quantity: 1,
                gstRate: 0,
                rate: 0,
                totalAmount: 0,
                totalPlusGst: 0,
                discount: 0,
                weight: 0,
                totalQty: 0,
                ratePerKg: 0,
                TotalAmtperkgwise: 0,
                GstPer: 0,
                gstAmt: 0,
                taxableAmt: 0,
                bundle: 0,
                pieces: 0,
                RateAfterDiscount: 0,
                Isdelete: 0,
                selectedPCategory,
                selectedCategory,
                selectedItem,
            });

            // Resetting other state variables
            setSelectedItem('');
            setQty('');
            setRate('');
            setGSTRate(0);
            setBundle('');
        }
    };
    const handleChange = event => {
        const { name, value } = event.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };


    const handleQuantityChange = (e, index) => {
        const { value } = e.target;
        const updatedItems = [...itemList];
        updatedItems[index].quantity = parseInt(value, 10);
        let bundleSize = 0;// Default to 1 if Bundle is null or 0

        const discountPerPiece = updatedItems[index].discountPerPiece || 0;
        const bag = updatedItems[index].bagWeight || 0;
        const bagweight = updatedItems[index].weight || 0;
        let BagWeight = 0;
        if (bag > 0) { //exixting
            BagWeight = bag;
            // bundleSize = parseInt(updatedItems[index].BundleAndPiece) || 0;
            bundleSize = parseInt(updatedItems[index].bundleAndPiece) || 0;
        }
        else if (bagweight > 0) {
            BagWeight = bagweight;
            bundleSize = parseInt(updatedItems[index].QtyBundle) || 0;

        }
        const numBundles = bundleSize ? Math.floor(value / bundleSize) : 0;
        const pieceCount = bundleSize ? value % bundleSize : 0;
        const totalQty = BagWeight * value;
        const ratePerKg = updatedItems[index].ratePerKg;
        const RateAfterDiscount = ratePerKg - discountPerPiece;
        const totalAmount = updatedItems[index].rate * updatedItems[index].quantity;
        const TotalAmtperkgwise = RateAfterDiscount * totalQty;
        const taxableAmt = (((RateAfterDiscount) * totalQty * 100) / (100 + updatedItems[index].gstRate));
        // const gstAmount = (totalAmount * updatedItems[index].GSTRate) / 100;
        const gstAmt = (taxableAmt * updatedItems[index].gstRate) / 100;
        const gstRate = updatedItems[index].gstRate;
        const GstPer = (gstAmt / taxableAmt) * 100;
        const netAmt = taxableAmt + gstAmt;
        updatedItems[index].RateAfterDiscount = RateAfterDiscount;
        updatedItems[index].gstAmt = gstAmt;
        updatedItems[index].netAmt = netAmt;
        updatedItems[index].discountPerPiece = discountPerPiece;
        updatedItems[index].totalQty = totalQty;
        updatedItems[index].gstRate = gstRate;
        updatedItems[index].taxableAmt = taxableAmt;
        updatedItems[index].bundle = numBundles;
        updatedItems[index].pieces = pieceCount;
        setItemList(updatedItems);
    };

    const handleDiscountChange = (e, index) => {
        const value = parseFloat(e.target.value) || 0;
        const updatedItems = [...itemList];
        updatedItems[index].discountPerPiece = value;
        const totalQty = updatedItems[index].totalQty;

        const rateperkg = updatedItems[index].ratePerKg;
        const RateAfterDiscount = rateperkg - updatedItems[index].discountPerPiece;
        const totalAmount = updatedItems[index].rate * updatedItems[index].quantity;
        const TotalAmtperkgwise = RateAfterDiscount * totalQty;
        const taxableAmt = (((RateAfterDiscount) * totalQty * 100) / (100 + updatedItems[index].gstRate));
        // const gstAmount = (totalAmount * updatedItems[index].GSTRate) / 100;
        const gstAmt = (taxableAmt * updatedItems[index].gstRate) / 100;
        const gstRate = updatedItems[index].gstRate;
        const GstPer = (gstAmt / taxableAmt) * 100;
        const netAmt = taxableAmt + gstAmt;
        updatedItems[index].RateAfterDiscount = RateAfterDiscount;
        updatedItems[index].gstAmt = gstAmt;
        updatedItems[index].netAmt = netAmt;
        updatedItems[index].discount = value;
        updatedItems[index].gstRate = gstRate;
        updatedItems[index].taxableAmt = taxableAmt;
        setItemList(updatedItems);
    };


    const handleQtyChange = (e) => {
        const input = e.target.value.replace(/\D/g, '');
        if (input.length <= 10) {
            setQty(input); // Update state with cleaned input

            const quantity = parseInt(input) || 0;

            const gstAmount = (rate * gstRate) / 100;
            const totalAmount = rate * quantity;
            const totalPlusGst = totalAmount + gstAmount;
            const totalQty = newItem.weight * quantity;

            // Update state with the new calculated values
            setNewItem((prevItem) => ({
                ...prevItem,
                quantity: quantity,
                totalAmount: totalAmount,
                gstRate: gstRate,
                gstAmount: gstAmount,
                totalPlusGst: totalPlusGst,

                discount: discount,
                totalQty: totalQty,
            }));
        }
    };
    const addRecord = async (e) => {
        e.preventDefault();
        let isValid = true;

        itemList.forEach((item) => {
            if (!item.quantity || item.quantity <= 0) {
                isValid = false;
            }
        });

        if (!isValid) {
            alert('Please Enter Quantity❗');
            setIsLoading(false);
            return;
        }


        const itemsToSave = itemList.map(item => ({
            ItemId: item.ItemId ? item.ItemId : (item.itemId ? item.itemId : null), // Choose ItemId or itemId
            CustomerId: customerId,
            CompanyId: companyId,
            CategoryId: categoryId,
            ProductCategoryId: item.productCateogryId ? item.productCateogryId : (item.ProductCategoryId ? item.ProductCategoryId : null),

            Rate: item.rate,
            Quantity: item.quantity,
            Discount: item.discount ? item.discount : 0,
            BilledDate: new Date(),
            CreatedBy: userId,
            CreatedDate: new Date(),
            RatePerKg: item.ratePerKg,
            DiscountPerPiece: item.discountPerPiece ? item.discountPerPiece : 0,
            TotalQty: item.totalQty,
            BagWeight: item.bagWeight || item.weight,
            CGSTAmt: (item.gstAmt / 2),
            SGSTAmt: (item.gstAmt / 2),
            GSTAmt: item.gstAmt,
            TaxableAmt: item.taxableAmt,
            NetAmt: item.netAmt,
            Bundle: item.bundle,
            Pieces: item.pieces
        }));

        const saleorderdata = {

            CustomerId: customerId,
            Id: id,
            SaleRemarks: formData.saleRemarks,
            OrderType: 1,
            CreatedBy: userId,
            CompanyId: companyId,
            RouteId: routeId,
            CreatedDate: new Date(),
        };

        const updateRecord = {
            SaleOrder: saleorderdata,
            SaleOrderDetails: itemsToSave,
        };

        try {
            const response = await updateData('AdditionalOrderEditAPI', id, updateRecord, token);
            console.log('Record updated successfully:', response);

            setTimeout(() => {
                setSuccessMessage("");
            }, 3000);
            setQuantity("");
            setSelectedItemsType("");

            fetchItemData();
            history.push(`/AddtionalOrderIndex/${tripId}`);


            setIsModalOpen(true);
        } catch (error) {
            console.error('Error updating record:', error);
        }

    };
    const [itemToDeleteIndex, setItemToDeleteIndex] = useState(null);
    const [itemName, setItemNames] = useState('');

    const openConfirmDialog = (index) => {
        setItemToDeleteIndex(index);
        setDeleteItemId(null);
        setItemNames('');
        setConfirmDialogOpen(true);
    };

    const ConfirmDialog = (index, deleteItemId, itemName = '') => {
        setItemToDeleteIndex(null);
        setDeleteItemId(deleteItemId);
        setItemNames(itemName);
        setConfirmDialogOpen(true);
    };


    const closeConfirmDialog = () => {
        setConfirmDialogOpen(false);
        setItemToDeleteIndex(null);
        setDeleteItemId(null);
        setItemNames('');
    };

    const handleDelete = () => {
        if (itemToDeleteIndex !== null) {
            const updatedItemList = itemList.filter((_, i) => i !== itemToDeleteIndex);
            setItemList(updatedItemList);

            closeConfirmDialog();

        }
        else if (deleteItemId !== null) {
            deleteData('AdditionalOrderEditAPI', `${deleteItemId}`, token)
                .then((response) => {
                    fetchData();
                    setDeleteItemId(null);
                    setConfirmDialogOpen(false);

                    //  handleRefreshClick();

                })
                .catch((error) => {
                    console.error('Error deleting record:', error);
                });
        }
        closeConfirmDialog();
        window.location.reload();
    };
    const handleRateChange = (e, index) => {
        const newRate = parseFloat(e.target.value) || 0;

        // Update the item at the specified index
        setItemList((prevItemList) => {
            return prevItemList.map((item, i) => {
                if (i === index) {
                    const quantity = item.quantity;
                    const totalQuantity = item.weight * quantity;
                    const totalAmount = newRate * totalQuantity;

                    const taxableAmt = ((newRate - item.singlediscount) * totalQuantity * 100) / (100 + item.gstRate);
                    const gstAmount = (taxableAmt * item.gstRate) / 100;
                    const totalPlusGst = taxableAmt + gstAmount;

                    return {
                        ...item,
                        rateperkg: newRate,
                        totalQuantity: totalQuantity,
                        taxableAmt: taxableAmt,
                        gstAmount: gstAmount,
                        totalPlusGst: totalPlusGst,
                        TotalAmtperkgwise: totalAmount,
                        GstPer: item.gstRate,
                    };
                }
                return item;
            });
        });
    };

    return (
        <div style={{ maxWidth: '100%', backgroundColor: '#f0f7f4', padding: '16px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)' }}>
            <div style={{ backgroundColor: 'white', padding: '16px', borderRadius: '8px' }}>
                {loading && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999
                    }}>
                        <div style={{ textAlign: 'center' }}>
                            <CircularProgress style={{ color: 'white' }} />
                            <span style={{ color: 'white', marginTop: '10px', display: 'block', fontSize: '14px' }}>Loading...</span>
                        </div>
                    </div>
                )}
                <form onSubmit={addRecord}>
                    {/* Header Section */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', paddingBottom: '12px', borderBottom: '2px solid #6b4c7a' }}>
                        <div>
                            <h2 style={{ margin: 0, fontSize: '18px', fontWeight: 'bold', color: '#6b4c7a', fontFamily: 'Arial, sans-serif', textTransform: 'uppercase' }}>
                                Additional Order Edit
                            </h2>
                            <div style={{ marginTop: '8px', fontSize: '13px', color: '#2c3e50' }}>
                                <strong>Order Date:</strong> {orderDate && new Date(orderDate).toLocaleDateString('en-GB')}
                            </div>
                        </div>
                        <div style={{ display: 'flex', gap: '8px' }}>
                            <Button 
                                variant="contained" 
                                type="submit" 
                                style={{ 
                                    minWidth: '120px', 
                                    height: '36px', 
                                    fontSize: '12px', 
                                    backgroundColor: '#10a37f', 
                                    color: 'white',
                                    fontWeight: 'bold',
                                    borderRadius: '18px',
                                    textTransform: 'none'
                                }}
                            >
                                Order Confirm
                            </Button>

                            <Tooltip title="Back To List">
                                <Link to={`/AddtionalOrderIndex/${tripId}`} style={{ textDecoration: 'none' }}>
                                    <Button 
                                        variant="contained" 
                                        color="error" 
                                        style={{ 
                                            height: '36px',
                                            fontSize: '12px',
                                            borderRadius: '18px',
                                            textTransform: 'none'
                                        }}
                                    >
                                        Back <ExitToAppIcon style={{ marginLeft: '4px', fontSize: '18px' }} />
                                    </Button>
                                </Link>
                            </Tooltip>
                        </div>
                    </div>

                    {/* Customer and Remarks Section */}
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '16px' }}>
                        <div>
                            <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#2c3e50', marginBottom: '6px' }}>
                                Customer
                            </label>
                            <input 
                                value={`${customerName} ${addressLine1}`} 
                                type="text" 
                                disabled 
                                style={{ 
                                    width: '100%', 
                                    padding: '8px 12px', 
                                    fontSize: '13px', 
                                    border: '1px solid #ddd', 
                                    borderRadius: '4px',
                                    height: '36px',
                                    backgroundColor: '#f8f9fa',
                                    color: '#6c757d'
                                }}
                            />
                        </div>

                        <div>
                            <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#2c3e50', marginBottom: '6px' }}>
                                Remarks
                            </label>
                            <input
                                name="SaleRemarks"
                                value={SaleRemarks}
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter Remark"
                                maxLength="100"
                                autoComplete='off'
                                style={{ 
                                    width: '100%', 
                                    padding: '8px 12px', 
                                    fontSize: '13px', 
                                    border: '1px solid #ddd', 
                                    borderRadius: '4px',
                                    height: '36px'
                                }}
                            />
                        </div>
                    </div>

                    {/* Product Selection Section */}
                    <div style={{ display: 'flex', gap: '12px', marginBottom: '16px', alignItems: 'flex-end' }}>
                        <div style={{ flex: '1' }}>
                            <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#2c3e50', marginBottom: '6px' }}>
                                Category
                            </label>
                            <Select
                                value={selectedPCategory}
                                onChange={handlePCategoryChange}
                                options={pcategoryOptions}
                                placeholder="Select Category"
                                isSearchable
                                menuPortalTarget={document.body}
                                styles={{
                                    control: (base) => ({ ...base, fontSize: '13px', minHeight: '36px' }),
                                    option: (base) => ({ ...base, fontSize: '13px' }),
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                }}
                            />
                        </div>

                        <div style={{ flex: '1' }}>
                            <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#2c3e50', marginBottom: '6px' }}>
                                Variant
                            </label>
                            <Select
                                value={selectedCategory}
                                onChange={handleCategoryChange}
                                options={categoryOptions}
                                placeholder="Select Variant"
                                isSearchable
                                menuPortalTarget={document.body}
                                styles={{
                                    control: (base) => ({ ...base, fontSize: '13px', minHeight: '36px' }),
                                    option: (base) => ({ ...base, fontSize: '13px' }),
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                }}
                            />
                        </div>

                        <div style={{ flex: '1' }}>
                            <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#2c3e50', marginBottom: '6px' }}>
                                Variant with Bagweight
                            </label>
                            <Select
                                value={selectedItem}
                                onChange={handleItemChange}
                                options={itemOptions}
                                placeholder="Select Item"
                                isSearchable
                                menuPortalTarget={document.body}
                                styles={{
                                    control: (base) => ({ ...base, fontSize: '13px', minHeight: '36px' }),
                                    option: (base) => ({ ...base, fontSize: '13px' }),
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                }}
                            />
                        </div>
                        <div style={{ flex: '0 0 150px' }}>
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="Quantity" style={{ fontSize: '15px' }}>
                                QTY (No.of pieces)

                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={qty}
                                onChange={handleQtyChange}
                                type="text"
                                placeholder="Quantity"
                                style={{ width: '150px', height: '37px' }}
                            />
                        </div>
                        <div className="w-1/7 mr-2">
                            <Button variant="contained" color="primary" onClick={AddtoListdata} style={{ marginTop: '32px', marginLeft: '10px', fontSize: '12px' }}>Add Item</Button>
                        </div>

                    </div>


                    <div style={{ marginTop: '16px', maxHeight: '500px', overflowY: 'auto', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)' }}>
                        <TableContainer component={Paper}>
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#6b4c7a' }}>
                                    <tr>
                                        <th style={{ color: 'white', fontWeight: 700, fontSize: '11px', padding: '8px 6px', textAlign: 'left', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)' }}>Name</th>
                                        <th style={{ color: 'white', fontWeight: 700, fontSize: '11px', padding: '8px 6px', textAlign: 'center', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)' }}>
                                            Qty<br /><span style={{ fontSize: '9px' }}>(No.Pieces)</span>
                                        </th>
                                        <th style={{ color: 'white', fontWeight: 700, fontSize: '11px', padding: '8px 6px', textAlign: 'right', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)' }}>
                                            Total Qty<br /><span style={{ fontSize: '9px' }}>(Kgs)</span>
                                        </th>
                                        <th style={{ color: 'white', fontWeight: 700, fontSize: '11px', padding: '8px 6px', textAlign: 'center', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)' }}>Bundle</th>
                                        <th style={{ color: 'white', fontWeight: 700, fontSize: '11px', padding: '8px 6px', textAlign: 'center', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)' }}>Pieces</th>
                                        <th style={{ color: 'white', fontWeight: 700, fontSize: '11px', padding: '8px 6px', textAlign: 'right', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)' }}>
                                            Rate/Kg<br /><span style={{ fontSize: '9px' }}>(Including Tax)</span>
                                        </th>
                                        <th style={{ color: 'white', fontWeight: 700, fontSize: '11px', padding: '8px 6px', textAlign: 'right', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)' }}>Discount</th>
                                        <th style={{ color: 'white', fontWeight: 700, fontSize: '11px', padding: '8px 6px', textAlign: 'right', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)' }}>
                                            Rate<br /><span style={{ fontSize: '9px' }}>(After Discount)</span>
                                        </th>
                                        <th style={{ color: 'white', fontWeight: 700, fontSize: '11px', padding: '8px 6px', textAlign: 'right', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)' }}>Taxable Amt</th>
                                        <th style={{ color: 'white', fontWeight: 700, fontSize: '11px', padding: '8px 6px', textAlign: 'center', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)' }}>GST%</th>
                                        <th style={{ color: 'white', fontWeight: 700, fontSize: '11px', padding: '8px 6px', textAlign: 'right', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)' }}>GST (₹)</th>
                                        <th style={{ color: 'white', fontWeight: 700, fontSize: '11px', padding: '8px 6px', textAlign: 'right', whiteSpace: 'nowrap' }}>Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {itemList.map((invdetail, index) => (
                                        <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#f8f9fa' : 'white', borderBottom: '1px solid #dee2e6' }}>
                                            <td style={{ fontSize: '11px', padding: '6px', textAlign: 'left', fontWeight: 'bold', borderRight: '1px solid #dee2e6' }}>{invdetail.item}</td>
                                            <td style={{ fontSize: '11px', padding: '6px', textAlign: 'center', borderRight: '1px solid #dee2e6', backgroundColor: invdetail.Quantity > invdetail.BalStock ? '#ffcccc' : 'inherit' }}>
                                                <input
                                                    type="number"
                                                    value={invdetail.quantity}
                                                    onChange={(e) => handleQuantityChange(e, index)}
                                                    name="quantity"
                                                    min="0"
                                                    step="1"
                                                    style={{ width: '100%', maxWidth: '80px', textAlign: 'right', padding: '4px', fontSize: '11px', border: '1px solid #ddd', borderRadius: '4px' }}
                                                />
                                            </td>
                                            <td style={{ fontSize: '11px', padding: '6px', textAlign: 'right', fontFamily: 'monospace', borderRight: '1px solid #dee2e6' }}>{invdetail.totalQty}</td>
                                            <td style={{ fontSize: '11px', padding: '6px', textAlign: 'center', borderRight: '1px solid #dee2e6' }}>{invdetail.bundle}</td>
                                            <td style={{ fontSize: '11px', padding: '6px', textAlign: 'center', borderRight: '1px solid #dee2e6' }}>{invdetail.pieces}</td>
                                            <td style={{ fontSize: '11px', padding: '6px', textAlign: 'right', borderRight: '1px solid #dee2e6', backgroundColor: invdetail.Quantity > invdetail.BalStock ? '#ffcccc' : 'inherit' }}>
                                                <input
                                                    type="text"
                                                    value={invdetail.ratePerKg}
                                                    style={{ width: '100%', maxWidth: '90px', textAlign: 'right', padding: '4px', fontSize: '11px', border: '1px solid #ddd', borderRadius: '4px' }}
                                                />
                                            </td>
                                            <td style={{ fontSize: '11px', padding: '6px', textAlign: 'right', borderRight: '1px solid #dee2e6' }}>
                                                <input
                                                    type="number"
                                                    value={(isNaN(invdetail.discountPerPiece) || invdetail.discountPerPiece === "") ? '0' : invdetail.discountPerPiece}
                                                    onChange={(e) => handleDiscountChange(e, index)}
                                                    step="0.01"
                                                    min="0"
                                                    style={{ width: '100%', maxWidth: '70px', textAlign: 'right', padding: '4px', fontSize: '11px', border: '1px solid #ddd', borderRadius: '4px' }}
                                                />
                                            </td>
                                                <td className="px-4 py-2 border-r text-right text-sm" style={{ padding: '8px', fontSize: '14px', width: '12%' }}>
                                                    {/* {((invdetail.discountPerPiece ?? 0) === 0 ? invdetail.ratePerKg : (invdetail.ratePerKg - invdetail.discountPerPiece))} */}
                                                    {((invdetail.discountPerPiece ?? 0) === 0
                                                        ? invdetail.ratePerKg
                                                        : (invdetail.ratePerKg - invdetail.discountPerPiece))}

                                                </td>

                                                <td className="px-4 py-2 border-r text-right text-sm" style={{ padding: '8px', fontSize: '14px', width: '7%' }}>
                                                    {invdetail.taxableAmt?.toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right text-sm" style={{ padding: '8px', fontSize: '14px', width: '45%' }}>
                                                    {invdetail.gstRate?.toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right text-sm" style={{ padding: '8px', fontSize: '14px', width: '9%' }}>
                                                    {invdetail.gstAmt?.toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right text-sm" style={{ padding: '8px', fontSize: '14px', width: '9%' }}>
                                                    {invdetail.netAmt?.toFixed(2)}
                                                </td>


                                                <td className="px-4 py-2 border-r text-right text-sm" style={{ padding: '8px', fontSize: '14px', width: '3%' }}>
                                                    <IconButton style={{ padding: '5px', marginTop: '-10px' }} onClick={() => removeRecord(index)}>
                                                        <DeleteIcon style={{ color: 'red' }} />
                                                    </IconButton>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                <tfoot>
                                    <tr style={{ backgroundColor: '#fff3cd', fontWeight: 'bold' }}>
                                        <td style={{ fontSize: '11px', padding: '8px', textAlign: 'left', borderRight: '1px solid #dee2e6', fontWeight: 'bold' }}>Total</td>
                                        <td style={{ fontSize: '11px', padding: '8px', textAlign: 'center', fontFamily: 'monospace', borderRight: '1px solid #dee2e6', fontWeight: 'bold' }}>
                                            {itemList.reduce((acc, item) => acc + item.quantity, 0)}
                                        </td>
                                        <td style={{ fontSize: '11px', padding: '8px', textAlign: 'right', fontFamily: 'monospace', borderRight: '1px solid #dee2e6', fontWeight: 'bold' }}>
                                            {itemList.reduce((acc, item) => acc + item.totalQty, 0)}
                                        </td>
                                        <td style={{ fontSize: '11px', padding: '8px', textAlign: 'center', fontFamily: 'monospace', borderRight: '1px solid #dee2e6', fontWeight: 'bold' }}>
                                            {itemList.reduce((acc, item) => acc + item.bundle, 0)}
                                        </td>
                                        <td style={{ fontSize: '11px', padding: '8px', textAlign: 'center', fontFamily: 'monospace', borderRight: '1px solid #dee2e6', fontWeight: 'bold' }}>
                                            {itemList.reduce((acc, item) => acc + item.pieces, 0)}
                                        </td>
                                        <td style={{ fontSize: '11px', padding: '8px', textAlign: 'right', fontFamily: 'monospace', borderRight: '1px solid #dee2e6', fontWeight: 'bold' }}>
                                            {itemList.reduce((acc, item) => {
                                                const ratePerKg = Number(item.ratePerKg);
                                                if (!isNaN(ratePerKg)) {
                                                    return acc + ratePerKg;
                                                }
                                                return acc;
                                            }, 0).toFixed(2)}
                                        </td>
                                        <td style={{ fontSize: '11px', padding: '8px', textAlign: 'right', fontFamily: 'monospace', borderRight: '1px solid #dee2e6', fontWeight: 'bold' }}>
                                            {itemList.reduce((acc, item) => {
                                                const singleDiscount = Number(item.discountPerPiece) || 0;
                                                return acc + singleDiscount;
                                            }, 0).toFixed(2)}
                                        </td>
                                        <td style={{ fontSize: '11px', padding: '8px', textAlign: 'right', fontFamily: 'monospace', borderRight: '1px solid #dee2e6', fontWeight: 'bold' }}>
                                            {itemList.reduce((acc, item) => {
                                                const ratePerKg = Number(item.ratePerKg) || 0;
                                                const singleDiscount = Number(item.discountPerPiece) || 0;
                                                if (!isNaN(ratePerKg) && !isNaN(singleDiscount)) {
                                                    return acc + (ratePerKg - singleDiscount);
                                                } else {
                                                    return acc;
                                                }
                                            }, 0).toFixed(2)}
                                        </td>
                                        <td style={{ fontSize: '11px', padding: '8px', textAlign: 'right', fontFamily: 'monospace', borderRight: '1px solid #dee2e6', fontWeight: 'bold' }}>
                                            {itemList.reduce((acc, item) => acc + item.taxableAmt, 0).toFixed(2)}
                                        </td>
                                        <td style={{ fontSize: '11px', padding: '8px', textAlign: 'center', fontFamily: 'monospace', borderRight: '1px solid #dee2e6', fontWeight: 'bold' }}>
                                            {itemList.reduce((acc, item) => acc + item.gstRate, 0).toFixed(2)}
                                        </td>
                                        <td style={{ fontSize: '11px', padding: '8px', textAlign: 'right', fontFamily: 'monospace', borderRight: '1px solid #dee2e6', fontWeight: 'bold' }}>
                                            {itemList.reduce((acc, item) => acc + item.gstAmt, 0).toFixed(2)}
                                        </td>
                                        <td style={{ fontSize: '11px', padding: '8px', textAlign: 'right', fontFamily: 'monospace', borderRight: '1px solid #dee2e6', fontWeight: 'bold' }}>
                                            {itemList.reduce((acc, item) => acc + item.netAmt, 0).toFixed(2)}
                                        </td>
                                        <td style={{ fontSize: '11px', padding: '8px', textAlign: 'center' }}></td>
                                    </tr>
                                </tfoot>

                                </table>


                                <Dialog
                                    open={confirmDialogOpen}
                                    onClose={closeConfirmDialog}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                >
                                    <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                                    <DialogContent>
                                        <DialogContentText id="alert-dialog-description">
                                            ⚠️ Are you sure you want to delete  "{itemnameget}" permanently?
                                        </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                        <button
                                            onClick={closeConfirmDialog}
                                            style={{
                                                backgroundColor: '#dc3545',
                                                color: '#ffffff',
                                                border: '1px solid #dc3545',
                                                borderRadius: '4px',
                                                padding: '8px 16px',
                                                cursor: 'pointer',
                                                marginRight: '8px',
                                            }}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            onClick={handleDelete}
                                            style={{
                                                backgroundColor: '#28a745',
                                                color: '#ffffff',
                                                border: '1px solid #28a745',
                                                borderRadius: '4px',
                                                padding: '8px 16px',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            Confirm
                                        </button>
                                    </DialogActions>
                                </Dialog>
                        </TableContainer>
                    </div>

                </form>
            </div>
        </div>
    );
};

export default AdditionalOrderEdit;
